<template>
	<ActivityPanelLayout class="kr-activity-panel">
		<template #title>{{ translate( "title" ) }}</template>
		<template #feed>
			<slot></slot>
		</template>
	</ActivityPanelLayout>
</template>

<script>
import ActivityPanelLayout from "../Activity/ActivityPanelLayout";
export default {
	name: "KRActivityPanel",
	components: {
		ActivityPanelLayout,
	},
	methods: {
		translate( key, args ) {
			return this.$t( `common-gokr.components.KRActivityPanel.${ key }`, args );
		},
	},
};
</script>

<style lang="scss" scoped></style>
